import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./dashboard.css";
import logoImg from "./RootServices.jpeg";

const cardList = [
  { label: "New Task", path: "/work" },
  { label: "Completed Task", path: "/worked" },
];

const EmployeeDashboard = () => {
  const navigate = useNavigate();
  const updateIntervalRef = useRef(null);

  // ✅ Get employee info from localStorage
  const employeeId = localStorage.getItem("employee_id");
  const employeeName = localStorage.getItem("employee_name") || "Employee";

  // 🛰️ Auto update employee location to backend
  useEffect(() => {
  const employeeId = localStorage.getItem("employee_id");

  const updateLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          fetch("http://localhost/rootservices/backend/update_agent_location.php", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  mode: "cors", // ✅ Important for CORS
  body: JSON.stringify({
    employee_id: employeeId,
    lat: position.coords.latitude,
    lng: position.coords.longitude,
  }),
})

            .then((res) => res.json())
            .then((data) => console.log("✅ Location updated:", data))
            .catch((err) => console.error("❌ Fetch error:", err));
        },
        (error) => {
          console.error("Geolocation error:", error);
        },
        { enableHighAccuracy: true }
      );
    }
  };

  // Run every 10 seconds
  const interval = setInterval(updateLocation, 10000);
  return () => clearInterval(interval);
}, []);


  // 🚪 Logout handler
  const handleLogout = async () => {
    if (updateIntervalRef.current) clearInterval(updateIntervalRef.current);

    if (employeeId) {
      try {
        const res = await fetch(
          "https://www.actrofiteinfotech.com/rootservices/dashboard/logout_employee.php",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ employee_id: employeeId }),
          }
        );
        const data = await res.json();
        if (data.status === "success") {
          localStorage.clear();
          navigate("/admin-login");
        } else {
          alert("Logout failed: " + data.message);
        }
      } catch (err) {
        console.error("Logout error:", err);
      }
    }
  };

  return (
    <div className="dashboard-container-light">
      <img src={logoImg} alt="Watermark Logo" className="dashboard-logo-bg-light" />

      <div className="dashboard-header-light">
        <img src={logoImg} alt="Root Services" className="dashboard-logo-top" />
        <h1 className="dashboard-title-light">Root Services Dashboard</h1>

        <p className="employee-name">👤 Welcome, {employeeName}</p>

        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="dashboard-grid-light">
        {cardList.map((card, index) => (
          <div
            key={index}
            className="dashboard-card-light"
            onClick={() => navigate(card.path)}
          >
            {card.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmployeeDashboard;
